module.exports = __webpack_public_path__ + "resources/img/img_main_bnr_makeit.e00058ed9e289eaf3e47d5d9d8d2e5c7.png";